// Module
var code = " <select name=\"rptLanguages\" id=\"rptLanguages\" ng-model=\"currentLanguage\"> <option ng-repeat=\"option in languages\" value=\"{{option.code}}\">{{option.name}}</option> </select>";
// Exports
module.exports = code;